import Vue from "vue";
import { createPinia, PiniaVuePlugin } from "pinia";

Vue.use(PiniaVuePlugin);

const piniaInstance = createPinia();

export default piniaInstance;
